module.exports = __webpack_public_path__ + "img/sc-2p-2024-2.64de8254.png";